// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + "sentry" + "." + "64e65231f00d2ad25ca0" + ".js";
};